<div class="container container-narrow">
    <h2>Confirm your account</h2>
    <p>
        Please check your email for a confirmation link to activate your account.
    </p>
    <p>
        If you did not receive the email, please check your spam folder.
    </p>
</div>
